<div class="row gx-0 mt-2">
  <div class="col d-flex align-items-center gap-2">
    <div class="text-center d-inline-block" [style.width]="DEFAULT_LOGO_CONTAINER_WIDTH">
      <app-ticket-comment-author-logo [comment]="comment"/>
    </div>
    <small class="text-body-secondary">
      {{ comment.author_full_name ? comment.author_full_name : '' }} -
      <span [title]="(comment.created_at | timezone: site?.timezone).format(TIMESTAMP_FORMAT) ">{{comment.created_at | timezone:site?.timezone | timeAgo}}</span>
      @if (canEditComment) {
        - <app-button visual="link" buttonClass="p-0" label="Edit" (buttonClick)="onEdit(comment.comment_id)"/>
      }
    </small>
  </div>
</div>
<div class="row gx-0">
  <div class="col">
    <div class="text-break text-prewrap"><span [innerHTML]="comment.text | linkify : {usersByEmail: assigneesByEmail}"></span></div>
  </div>
</div>
